var $107b5e2e45e971f1$exports = {};
$107b5e2e45e971f1$exports = {
  "dragDescriptionKeyboard": "Ap\u0103sa\u021Bi pe Enter pentru a \xEEncepe glisarea.",
  "dragDescriptionKeyboardAlt": "Ap\u0103sa\u021Bi pe Alt + Enter pentru a \xEEncepe glisarea.",
  "dragDescriptionLongPress": "Ap\u0103sa\u021Bi lung pentru a \xEEncepe glisarea.",
  "dragDescriptionTouch": "Atinge\u021Bi de dou\u0103 ori pentru a \xEEncepe s\u0103 glisa\u021Bi.",
  "dragDescriptionVirtual": "Face\u021Bi clic pentru a \xEEncepe glisarea.",
  "dragItem": function dragItem(args) {
    return "Glisa\u021Bi ".concat(args.itemText);
  },
  "dragSelectedItems": function dragSelectedItems(args, formatter) {
    return "Glisa\u021Bi ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " element selectat");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " elemente selectate");
      }
    }));
  },
  "dragSelectedKeyboard": function dragSelectedKeyboard(args, formatter) {
    return "Ap\u0103sa\u021Bi pe Enter pentru a glisa ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " element selectat");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " elemente selectate");
      }
    }), ".");
  },
  "dragSelectedKeyboardAlt": function dragSelectedKeyboardAlt(args, formatter) {
    return "Ap\u0103sa\u021Bi pe Alt + Enter pentru a glisa ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " element selectat");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " elemente selectate");
      }
    }), ".");
  },
  "dragSelectedLongPress": function dragSelectedLongPress(args, formatter) {
    return "Ap\u0103sa\u021Bi lung pentru a glisa ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " element selectat");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " elemente selectate");
      }
    }), ".");
  },
  "dragStartedKeyboard": "A \xEEnceput glisarea. Ap\u0103sa\u021Bi pe Tab pentru a naviga la o \u021Bint\u0103 de fixare, apoi ap\u0103sa\u021Bi pe Enter pentru a fixa sau ap\u0103sa\u021Bi pe Escape pentru a anula glisarea.",
  "dragStartedTouch": "A \xEEnceput glisarea. Naviga\u021Bi la o \u021Bint\u0103 de fixare, apoi atinge\u021Bi de dou\u0103 ori pentru a fixa.",
  "dragStartedVirtual": "A \xEEnceput glisarea. Naviga\u021Bi la o \u021Bint\u0103 de fixare, apoi face\u021Bi clic sau ap\u0103sa\u021Bi pe Enter pentru a fixa.",
  "dropCanceled": "Fixare anulat\u0103.",
  "dropComplete": "Fixare finalizat\u0103.",
  "dropDescriptionKeyboard": "Ap\u0103sa\u021Bi pe Enter pentru a fixa. Ap\u0103sa\u021Bi pe Escape pentru a anula glisarea.",
  "dropDescriptionTouch": "Atinge\u021Bi de dou\u0103 ori pentru a fixa.",
  "dropDescriptionVirtual": "Face\u021Bi clic pentru a fixa.",
  "dropIndicator": "indicator de fixare",
  "dropOnItem": function dropOnItem(args) {
    return "Fixa\u021Bi pe ".concat(args.itemText);
  },
  "dropOnRoot": "Fixare pe",
  "endDragKeyboard": "Se gliseaz\u0103. Ap\u0103sa\u021Bi pe Enter pentru a anula glisarea.",
  "endDragTouch": "Se gliseaz\u0103. Atinge\u021Bi de dou\u0103 ori pentru a anula glisarea.",
  "endDragVirtual": "Se gliseaz\u0103. Face\u021Bi clic pentru a anula glisarea.",
  "insertAfter": function insertAfter(args) {
    return "Insera\u021Bi dup\u0103 ".concat(args.itemText);
  },
  "insertBefore": function insertBefore(args) {
    return "Insera\u021Bi \xEEnainte de ".concat(args.itemText);
  },
  "insertBetween": function insertBetween(args) {
    return "Insera\u021Bi \xEEntre ".concat(args.beforeItemText, " \u0219i ").concat(args.afterItemText);
  }
};
export { $107b5e2e45e971f1$exports as default };